import Model from 'src/app/common/model';

export default class ShapesModel extends Model {
  name: string;
  description: string;
  code: string;

  constructor() {
    super();
  }
}
